import {
  Box,
  Button,
  FormHelperText,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { fade } from '@material-ui/core/styles/colorManipulator';

import { SELECT_PROP_TYPES } from '../SelectControl/constants';

const useStyles = makeStyles((theme) => ({
  pillGroup: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10,
  },
  pill: {
    borderRadius: 999,
    minWidth: 44,
    height: 34,
    padding: '0 18px',
    border: `1px solid ${theme.palette.grey[300]}`,
    color: theme.palette.text.primary,
    textTransform: 'none',
    fontSize: 13,
    fontWeight: 700,
    backgroundColor: theme.palette.common.white,
  },
  pillActive: {
    backgroundColor: fade(theme.palette.secondary.main, 0.1),
    color: theme.palette.secondary.main,
    borderColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: fade(theme.palette.secondary.main, 0.16),
    },
  },
  pillCompact: {
    minWidth: 30,
    height: 30,
    padding: '0 12px',
    fontSize: 12,
  },
}));

function PillSelectControl(props) {
  const classes = useStyles();
  const {
    disabled,
    display = {},
    error,
    events = {},
    helperText,
    label,
    name,
    onChange,
    settings = {},
    value,
  } = props;
  let { options = [] } = settings;

  const labelStyle = {
    textTransform: 'none',
    letterSpacing: '0.08em',
    fontSize: '11px',
    fontWeight: 700,
    color: '#6B7A90',
    ...display?.labelStyle,
  };

  if (disabled) {
    labelStyle.color = '#0000004e';
  }

  if (typeof options === 'function') {
    options = options();
  }

  const handleClick = (option) => {
    const target = {
      name,
      value: option?.id,
    };
    onChange({
      target,
    });

    if (events.onChange) {
      events.onChange(target);
    }
  };

  return (
    <Box sx={{
      mb: 2,
    }}>
      <Typography style={labelStyle} variant="h6" gutterBottom>
        {label}
      </Typography>
      <Box className={classes.pillGroup}>
        {options.map((option) => {
          const isActive = String(value) === String(option?.id);
          return (
            <Button
              className={`${classes.pill} ${settings.compact ? classes.pillCompact : ''} ${isActive ? classes.pillActive : ''}`}
              disabled={disabled}
              key={`${name}_${option?.id}`}
              onClick={() => handleClick(option)}
              variant="outlined"
            >
              {option?.name}
            </Button>
          );
        })}
      </Box>
      {helperText && (
        <FormHelperText error={error}>
          {helperText}
        </FormHelperText>
      )}
    </Box>
  );
}

PillSelectControl.propTypes = SELECT_PROP_TYPES;

PillSelectControl.defaultProps = {
  disabled: false,
  settings: {
    options: [],
    compact: false,
  },
  onChange: () => { },
};

export default PillSelectControl;
